import tpl from './developSummary.html';
import "./developSummary.css";

class DevelopSummary {
    constructor(container, opts) {
        this.container = container;
        this.container.innerHTML = tpl;
    }
}

export {
    DevelopSummary
}